import {
  REMOVE_UNSELECT_EMPLOYEE,
  REST_UNSELECT_EMPLOYEE,
  SET_UNSELECT_EMPLOYEE,
} from "redux/constants/UnSelecteContant";

const INITIAL_STATE = {
  unselectedEmployee: [],
};

const unSelectedReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_UNSELECT_EMPLOYEE:
      return {
        ...state,
        unselectedEmployee: [...state.unselectedEmployee, action.payload],
      };
    case REMOVE_UNSELECT_EMPLOYEE:
      return {
        ...state,
        unselectedEmployee: state.unselectedEmployee.filter(
          (key) => key !== action.payload
        ),
      };
    case REST_UNSELECT_EMPLOYEE:
      return action.payload;
    default:
      return state;
  }
};

export default unSelectedReducer;
